import { useMutation, useQueryClient } from '@tanstack/react-query'
import { answerApi } from '@/services/answers/answers'
import { toast } from 'react-toastify'
import { handleError } from '@/utils/helpers'

interface ConfirmJDParams {
  answerId: string
  isAnonymous?: boolean
}

export const useConfirmJD = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ answerId, isAnonymous }: ConfirmJDParams) =>
      answerApi.confirmJD(answerId, isAnonymous),
    onSuccess: () => {
      toast.success('Đã tạo JD thành công!')
      // Invalidate queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ['myJobDescription'] })
      queryClient.invalidateQueries({ queryKey: ['jobDescriptions'] })
    },
    onError: (error: Error) => {
      handleError(error, { fallbackMessage: 'Lỗi khi tạo JD' })
    },
  })
}
